import { VCard } from 'vuetify/lib/components/VCard';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VCard,{staticClass:"pa-0 ma-0",attrs:{"elevation":"0","flat":""}},[_c(VOverlay,{attrs:{"value":_vm.loading,"absolute":"","color":"white","opacity":".8"}},[_c(VProgressCircular,{attrs:{"color":"secondary","indeterminate":"","size":"64"}})],1),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }